import * as _postcss2 from "postcss";
var _postcss = "default" in _postcss2 ? _postcss2.default : _postcss2;
import _processResult from "./process-result";
import _parser from "./parser";
var exports = {};
let postcss = _postcss;
let processResult = _processResult;
let parse = _parser;
exports = function (plugins) {
  let processor = postcss(plugins);
  return input => {
    let result = processor.process(input, {
      parser: parse,
      from: undefined
    });
    return processResult(result);
  };
};
export default exports;